<div class="container-fluid footer">
    <div class="row mb-4">
        <div class="col-5 align-self-center display-none">
            <hr class="horz-line">
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <img class="footer-img" src="https://specscart.co.uk/skin/frontend/rwd/default/img/logo_symbol.svg" alt="">
        </div>
        <div class="col-5 align-self-center display-none">
            <hr class="horz-line">
        </div>
    </div>
    <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-lg-start text-md-start text-sm-center text-xs-center">
            <p class="para">GLASSES</p>
            <ul class="list">
                <li><a class="hyper" href="">Round Glasses</a></li>
                <li><a class="hyper" href="">Wayfarer Glasses</a></li>
                <li><a class="hyper" href="">Cat-Eye Glasses</a></li>
                <li><a class="hyper" href="">Rectangular Glasses</a></li>
                <li><a class="hyper" href="">Rimless Glasses</a></li>
                <li><a class="hyper" href="">Verifocal Glasses</a></li>
                <li><a class="hyper" href="">Transitions Glasses</a></li>
            </ul>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-lg-start text-md-start text-sm-center text-xs-center">
            <p class="para">SUNGLASSES</p>
            <ul class="list">
                <li><a class="hyper" href="">Aviator Sunglasses</a></li>
                <li><a class="hyper" href="">Round Sunglasses</a></li>
                <li><a class="hyper" href="">Cat Eye Sunglasses</a></li>
                <li><a class="hyper" href="">Wayfarer Sunglasses</a></li>
                <li><a class="hyper" href="">Polarised Sunglasses</a></li>
                <li><a class="hyper" href="">Prescription Sunglasses</a></li>
            </ul>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-lg-start text-md-start text-sm-center text-xs-center">
            <p class="para">HELP & FAQ</p>
            <ul class="list">
                <li><a class="hyper" href="">Your Prescription</a></li>
                <li><a class="hyper" href="">Digital Blue Glasses</a></li>
                <li><a class="hyper" href="">Lenses & Coatings</a></li>
                <li><a class="hyper" href="">Anti Reflective Lenses</a></li>
                <li><a class="hyper" href="">How to order</a></li>
                <li><a class="hyper" href="">Delivery Information</a></li>
                <li><a class="hyper" href="">Free Returns</a></li>
            </ul>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-lg-start text-md-start text-sm-center text-xs-center">
            <p class="para">ABOUT US</p>
            <ul class="list">
                <li><a class="hyper" href="">Our Story</a></li>
                <li><a class="hyper" href="">Contact Us</a></li>
                <li><a class="hyper" href="">Our Blog</a></li>
                <li><a class="hyper" href="">Privacy Policy</a></li>
                <li><a class="hyper" href="">Franchise</a></li>
            </ul>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
            <div class="row justify-content-between">
                <div class="col-auto">
                    <p>SUBSCRIBE</p>
                </div>
                <div class="col-auto">
                    <p>CONTACT US</p>
                </div>
            </div>
            <div class="row">
                <div class="input-group mb-5">
                    <input class="form-control" type="text" placeholder="Sign up for our newsletter"
                        aria-label="newsletter" aria-describedby="newsletter">
                    <button class="btn btn-outline-secondary news-btn" type="button" id="newsletter"><img
                            style="width: 22px;" src="../../assets/send.png" alt=""></button>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-auto">
                    <a class="hyper mx-3" href=""><img class="social my-2" src="../../assets/facebook.png" alt=""></a>
                    <a class="hyper mx-3" href=""><img class="social my-2" src="../../assets/twitter.png" alt=""></a>
                    <a class="hyper mx-3" href=""><img class="social my-2" src="../../assets/insta.png" alt=""></a>
                    <a class="hyper mx-3" href=""><img class="social my-2" src="../../assets/yt.png" alt=""></a>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <hr class="horz-line">
        </div>
    </div>
    <div class="row">
        <div
            class="col-lg-6 col-md-6 col-sm-12 col-xs-12 align-self-center text-lg-start text-md-start text-sm-center text-xs-center">
            <p class="mb-0">Developed by HRM International Limited © 2021 Specscart.</p>
        </div>
        <div
            class="col-lg-6 col-md-6 col-sm-12 col-xs-12 align-self-center text-lg-end text-md-end text-sm-center text-xs-center">
            <a class="d-inline hyper" href="">Terms and Conditions &nbsp; | </a>
            <a class="d-inline hyper ms-3" href="">Privacy Policy &nbsp; | </a>
            <a class="d-inline hyper ms-3" href="">Site Map</a>
        </div>
    </div>
</div>